import { useRef, useState, useEffect } from 'react';

export function useSetTemporaryState(defaultValue: any, delay: any) {
  const valueRef = useRef(defaultValue);
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    if (valueRef.current === value) return;

    const timeoutId = setTimeout(() => {
      setValue(valueRef.current);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, setValue, delay]);

  return [value, setValue];
}
